'use client';
/**
 * better-auth browser client. Editor stream: `import { authClient } from '@/auth/client'`.
 *   authClient.signIn.anonymous()
 *   authClient.signIn.social({ provider: 'google' })
 *   authClient.linkSocial({ provider: 'google' })   // attach Google to the account already signed in
 *   authClient.signIn.email({ email, password })
 *   authClient.signUp.email({ name, email, password })
 */
import { createAuthClient } from 'better-auth/react';
import { anonymousClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  basePath: '/api/auth',
  plugins: [anonymousClient()],
});

export const { signIn, signOut, signUp, useSession, getSession, linkSocial } = authClient;
